import { Component, OnInit } from '@angular/core';
import { ProviderInvoiceComponent } from './provider/provider-invoice/provider-invoice.component';
import { InvoiceConsumerListComponent } from './consumer/invoice-consumer-list/invoice-consumer-list.component';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'ppl-invoice-detail',
  standalone: true,
  imports: [ProviderInvoiceComponent, InvoiceConsumerListComponent],
  templateUrl: './invoice-detail.component.html',
})
export class InvoiceDetailComponent implements OnInit {
  program: any;
  entry: any;
  isParticipantFlow = false;

  constructor(private userService: UserService) {}

  ngOnInit(): void {
    this.entry = this.userService.getLeadEntry();
    this.isParticipantFlow = this.entry == 'participantEnrollment';
  }
}
